<template>
    <transition :name="'fade'"  :css="clubTransitionEnabled" mode="out-in">
        <div v-if="clubData.visible">

            <CustomReveal class="event-modal"
                revealId="club-profile-card"
                v-if="clubData.mode !== 'create'"
                :isVisible="clubData.visible"
                v-on:close-reveal-club-profile-card="closeClub">
                <div id="event-profile-card" class="event-card"
                    data-reveal2>
                    <ViewClub v-if="clubData.mode === 'view'" :clubId="clubData.clubId" />
                    <EditClub v-if="clubData.mode === 'edit'"/>
                </div>

                <UserPhotosReveals v-if="club" :photos="club.photos"></UserPhotosReveals>
                <UserVideosReveals v-if="club" :videos="club.videos"></UserVideosReveals>
            </CustomReveal>

            <CreateClub v-if="clubData.mode === 'create'"/>

        </div>
    </transition>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import CustomReveal from '@buddy/views/widgets/CustomReveal.vue';
    import UserPhotosReveals from '@buddy/views/widgets/UserPhotosReveals.vue';
    import UserVideosReveals from '@buddy/views/widgets/UserVideosReveals.vue';

    import ViewClub from '@clubs/views/desktop/club/Item.vue';
    import EditClub from '@clubs/views/desktop/club/Edit.vue';
    import CreateClub from '@clubs/views/desktop/club/Create.vue';

    import clubsModule from '@clubs/module/store/type'

    export default {
        mixins: [
            require('@general/lib/mixin-clubs').default,
        ],
        components: {
            CustomReveal,
            UserPhotosReveals,
            UserVideosReveals,
            EditClub,
            ViewClub,
            CreateClub
        },
        computed: {
            ...mapGetters({
                clubTransitionEnabled : clubsModule.getters.clubTransitionEnabled,
                clubData: clubsModule.getters.club
            }),
            club(){
                return this.$store.getters.getClub(this.clubData.clubId)
            },
        },
        methods: {
            ...mapActions({
                setClub: clubsModule.actions.setClub
            })
        },
    }
</script>
